export default "__VITE_ASSET__fa432366__"